module.exports = __webpack_public_path__ + "static/img/dress_neck_default.899316ab.png";